<template>
  <div id="app">
    <router-view/>
    <template class="emailreply" tag>
      <emailReplyCopy v-if="!isIstore"/>
      <emailReply v-if="!isIstore"/>
    </template>
  </div>
</template>

<script>
import emailReplyCopy from '@/components/emailReplyCopy/index.vue'
import emailReply from '@/components/emailReply/index.vue'
export default {
  name: 'App',
  components: { emailReplyCopy, emailReply },
  computed: {
    isIstore() {
      return window.location.host.indexOf('szecommerce.com') > -1 || window.location.host.indexOf('suntekcorps.cn') > -1
    }
  }
}
</script>
